export const ROUTE_CONST = {
  PARAMS: {
    ACCOUNT_ID: ":accountId",
    REPORT_ID: ":reportId",
  },
  ROOT: "/",
  INVITE: "invite",
  PROFILE: "profile",
  VIDEO_EDITOR: "video-editor",

  ANALYZE: "analyze",
  SHARE: "share",
  OVERVIEW: "overview",
  REPORT: "report",
  REPORTS: "reports",
  FATIGUE: "fatigue",

  RESEARCH: "research",
  COMMENTS: "comments",
  COMPETITOR_ADS: "competitor-ads",
  FOLDER: "folder",
  COMPETITOR_REPORTS: "competitor-reports",

  CREATE: "create",
  EXPLORE: "explore",
  PUBLISH: "publish",
  WORKFLOW: "workflow",

  SETTINGS: "settings",
  TEAM: "team",
  INSTRUCTIONS: "instructions",
  SETUP: "setup",
  WINNING_CRITERIA: "winning-criteria",
  CREATIVE_OVERVIEW: "creative-overview",
  LABELS: "labels",
  EXTENSION: "extension",
} as const;
// Add route builders
export const buildRoute = {
  invite: () => `/${ROUTE_CONST.INVITE}`,
  profile: () => `/${ROUTE_CONST.PROFILE}`,
  video_editor: () => `/${ROUTE_CONST.VIDEO_EDITOR}`,
  account: (accountId?: string) => (accountId ? `/${accountId}` : "/"),
  analyze: (accountId: string) =>
    accountId ? `/${accountId}/${ROUTE_CONST.ANALYZE}` : "/",
  overview: (accountId: string) =>
    accountId ? `/${accountId}/${ROUTE_CONST.ANALYZE}/${ROUTE_CONST.OVERVIEW}` : "/",
  reports: (accountId: string) =>
    accountId ? `/${accountId}/${ROUTE_CONST.ANALYZE}/${ROUTE_CONST.REPORTS}` : "/",
  report: (accountId: string, reportId: string) =>
    `/${accountId}/${ROUTE_CONST.ANALYZE}/${ROUTE_CONST.REPORTS}/${reportId}`,
  fatigue: (accountId: string) =>
    accountId ? `/${accountId}/${ROUTE_CONST.ANALYZE}/${ROUTE_CONST.FATIGUE}` : "/",
  research: (accountId: string) =>
    accountId ? `/${accountId}/${ROUTE_CONST.RESEARCH}` : "/",
  competitorReport: (accountId: string, reportId?: string) => {
    let path = `/${accountId}/${ROUTE_CONST.RESEARCH}/${ROUTE_CONST.COMPETITOR_REPORTS}`;
    if (reportId) {
      path += `/${reportId}`;
    }
    return path;
  },
  create: (accountId: string) =>
    accountId ? `/${accountId}/${ROUTE_CONST.CREATE}` : "/",
  publish: (accountId: string) =>
    accountId ? `/${accountId}/${ROUTE_CONST.CREATE}/${ROUTE_CONST.PUBLISH}` : "/",
  settings: (accountId: string) =>
    accountId ? `/${accountId}/${ROUTE_CONST.SETTINGS}` : "/",
  team: (accountId: string) =>
    `/${accountId}/${ROUTE_CONST.SETTINGS}/${ROUTE_CONST.TEAM}`,
};
